<template>
    <div class="main">

        <a-card :loading="tableLoading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <!-- <router-link to="/customers"
                    style="font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
                    <p>
                        <a-icon type="double-left" />
                    </p>
                    <p>Go Back To Customers</p>

                </router-link> -->
            </div>
            <div>
                <h3 style="font-size:28px;line-height:45px">Sub Account's Details</h3>
            </div>
            <div>
                <a-row>
                    <a-col :span="24">
                        <div>
                            <a-row class="pb-2">
                                <a-col :span="8">
                                    <div style="font-size:18px;">Name: </div>
                                </a-col>
                                <a-col :span="8" :offset="4">
                                    <div style="font-size:18px;">{{ customerDetails.name ? customerDetails.name :
                                        'N/A' }}</div>
                                </a-col>
                            </a-row>
                            <a-row class="pb-2">
                                <a-col :span="8">
                                    <div style="font-size:18px;">Phone Number: </div>
                                </a-col>
                                <a-col :span="8" :offset="4">
                                    <div style="font-size:18px;">{{ customerDetails.phoneNumber ?
                                        customerDetails.phoneNumber :
                                        'N/A' }}</div>
                                </a-col>
                            </a-row>
                            <a-row class="pb-2">
                                <a-col :span="8">
                                    <div style="font-size:18px;">Sex: </div>
                                </a-col>
                                <a-col :span="8" :offset="4">
                                    <div style="font-size:18px;">{{ customerDetails.sex ?
                                        customerDetails.sex : 'N/A' }}</div>
                                </a-col>
                            </a-row>
                            <a-row class="pb-2">
                                <a-col :span="8">
                                    <div style="font-size:18px;">Reference: </div>
                                </a-col>
                                <a-col :span="8" :offset="4">
                                    <div style="font-size:18px;">{{ customerDetails.reference ?
                                        customerDetails.reference : 'N/A' }}</div>
                                </a-col>
                            </a-row>


                            <a-row class="pb-2">
                                <a-col :span="8">
                                    <div style="font-size:18px;">Address: </div>
                                </a-col>
                                <a-col :span="8" :offset="4">
                                    <div style="font-size:18px;">{{ customerDetails.address ?
                                        customerDetails.address : 'N/A' }}</div>
                                </a-col>
                            </a-row>

                        </div>

                    </a-col>

                </a-row>
            </div>
            <div class="card-container mt-4">
                <a-tabs type="card">
                    <a-tab-pane key="1">
                        <span slot="tab">
                            <span>
                                <a-icon type="unordered-list" />
                            </span>
                            Poultry
                            <a-badge style="float:right;padding-top:9px" :count="displayPolutry" show-zero />
                        </span>
                        <div class="requestActions">
                            <!-- <a-form-model
                                        :model="orderform"
                                    >
                                        <a-form-model-item>
                                            <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                                <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                            </a-input>
                                        </a-form-model-item>
                                    </a-form-model> -->
                            <div>
                                <a-button @click="showPoultryModal"
                                    style="height:38px;border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                                    Add Poultry Batch
                                </a-button>
                            </div>
                        </div>
                        <div>
                            <a-table :columns="poultryColumns" :scroll="{ x: 1500 }" :data-source="tablePoultry"
                                :loading='tableLoading' :pagination="pagination" class="tableStyle">
                                <template slot="tier" slot-scope='data'>
                                    <div
                                        style="display: flex;padding-top: 4px;justify-content: space-around;background: #3f51b5;width: 140px;height: 27px;border-radius: 30px">
                                        <p style="font-size:12px;color:#fff;">Tier {{ data }}</p>
                                    </div>
                                </template>

                                <template slot="status" slot-scope='data'>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #87d068;width: 140px;height: 27px;border-radius: 30px"
                                        v-if="data === `Enabled`">
                                        <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#fff;"> {{ data }}</p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #ff5500;width: 140px;height: 27px;border-radius: 30px"
                                        v-if="data === `Disabled`">
                                        <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#fff;">{{ data }}</p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 140px;height: 27px;border-radius: 30px"
                                        v-if="data === `Pending`">
                                        <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#ffb102;"> {{ data }}</p>
                                    </div>
                                </template>

                                <template slot="action" slot-scope="data">
                                    <a-dropdown>
                                        <a style="color:#98c14b;" class="ant-dropdown-link"
                                            @click="e => e.preventDefault()">
                                            <a-icon style="font-size:25px;" type="ellipsis" />
                                        </a>
                                        <a-menu slot="overlay">
                                            <a-menu-item>
                                                <a @click="showMoreDetailsModal(data)">More Details?</a>
                                            </a-menu-item>
                                        </a-menu>
                                    </a-dropdown>
                                </template>
                            </a-table>
                        </div>

                    </a-tab-pane>
                </a-tabs>
            </div>
        </a-card>

        <invoice ref="invoiceRef"></invoice>
        <download-invoice ref="invoiceDownloadRef"></download-invoice>

        <a-modal class="modalStyle" :visible="addPoultryBatchVisible" :footer="null" width="700px"
            @cancel="closePoultryModal">
            <p style="text-align:center;font-weight: bolder;padding-top: 10px;"> Add Poultry Batch</p>
            <div style="padding: 10px;">
                <a-form-model ref="addPoultryeRef" :model="addPoultryModel" :rules="rules">
                    <a-row>
                        <a-col :span="24" :offset="0">
                            <a-form-model-item label="Batch ID" ref="batchId" prop="batchId">
                                <a-input class="" v-model="addPoultryModel.batchId" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Vaccine Template" ref="vaccineTemplate" prop="vaccineTemplate">
                                <a-select v-model="addPoultryModel.vaccineTemplate"
                                    placeholder="please select your template">
                                    <a-select-option v-for="temp in templates" :key="temp.id" v-bind:value="temp.id">
                                        {{ temp.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="4">
                            <a-form-model-item label="Template Type" ref="type" prop="type">
                                <a-select v-model="addPoultryModel.type" placeholder="please select your type">
                                    <a-select-option v-bind:value="1"> Broiler </a-select-option>
                                    <a-select-option v-bind:value="0"> Layer </a-select-option>
                                    <a-select-option v-bind:value="2"> Hybrid </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Species" ref="species" prop="species">
                                <a-select v-model="addPoultryModel.species" placeholder="please select your species">
                                    <a-select-option v-bind:value="0"> Chicken </a-select-option>
                                    <a-select-option v-bind:value="1"> GuineaFowl </a-select-option>
                                    <a-select-option v-bind:value="2"> Turkey </a-select-option>
                                    <a-select-option v-bind:value="3"> Duck </a-select-option>
                                    <a-select-option v-bind:value="4"> Quail </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="4">
                            <a-form-model-item label="Breed" ref="breed" prop="breed">
                                <a-select v-model="addPoultryModel.breed" placeholder="please select your breed">
                                    <a-select-option v-for="breed in breeds" :key="breed.id" v-bind:value="breed.id">
                                        {{ breed.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Size" ref="size" prop="size">
                                <a-input class="" v-model="addPoultryModel.size" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="4">
                            <a-form-model-item label="Age(days)" ref="age" prop="age">
                                <a-input class="" v-model="addPoultryModel.age" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Source Name" ref="source" prop="source">
                                <a-input class="" v-model="addPoultryModel.source" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="4">
                            <a-form-model-item label="Source Type" ref="sourceType" prop="sourceType">
                                <a-select v-model="addPoultryModel.sourceType"
                                    placeholder="please select your source type">
                                    <a-select-option v-for="suppliersType in suppliersTypes" :key="suppliersType.id"
                                        v-bind:value="suppliersType.id">
                                        {{ suppliersType.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-form-model-item label="Notes" ref="notes" prop="notes">
                            <a-textarea v-model="addPoultryModel.notes" placeholder=""
                                :auto-size="{ minRows: 3, maxRows: 5 }" />
                        </a-form-model-item>
                    </a-row>
                </a-form-model>

            </div>

            <div style="display: flex;justify-content: center;padding-top:30px">
                <a-button @click="handleAddPoultryBatch" :loading="loading"
                    style="background: #418a49;color:#fff;border-radius:5px;">
                    Add Poultry Batch
                </a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment';
// import XLSX from "xlsx";
// import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Invoice from './custom/Invoice.vue'
import DownloadInvoice from './custom/DownloadInvoice.vue'


const poultryColumns = [
    {
        title: 'Batch Id',
        width: 150,
        key: 'batchNumber',
        dataIndex: 'batchNumber',
    },
    {
        title: 'Customer Name',
        dataIndex: 'customerName',
        key: 'customerName',
        width: 150,
    },
    {
        title: 'Breed',
        dataIndex: 'breedName',
        key: 'breedName',
        width: 150,
    },
    {
        title: 'Source',
        dataIndex: 'source',
        key: 'source',
        width: 150,
    },
    {
        title: 'Source ID',
        dataIndex: 'sourceName',
        key: 'sourceName',
        width: 150,
    },
    {
        title: 'Species',
        dataIndex: 'poultrySpeciesLabel',
        key: 'poultrySpeciesLabel',
        width: 150,
    },
    {
        title: 'Size',
        dataIndex: 'size',
        key: 'size',
        width: 150,
    },
    {
        title: 'Age(days)',
        dataIndex: 'age',
        key: 'age',
        width: 150,
    },
    {
        title: 'Template Name',
        dataIndex: 'vaccineTemplateName',
        key: 'vaccineTemplateName',
        width: 150,
    },
    {
        title: 'Created Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 150,
    },
    {
    title: 'Action',
    key: 'action',
    fixed: 'right',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
    },
];

export default {
    name: 'SubCustomersDetails',
    // props: ['items'],
    components: {
        Invoice,
        DownloadInvoice
    },
    data() {
        return {
            customerDetails: {},
            templates: [],
            data: [],
            id: '',
            addPoultryModel: {
                batchId: '',
                type: '',
                species: '',
                breed: '',
                size: '',
                age: '',
                vaccineTemplate: '',
                source: '',
                sourceType: '',
                sourceContact: '',
                notes: ''

            },
            tablePoultry: [],
            suppliersTypes: [],
            poultryColumns,
            dateFormat: 'DD/MM/YYYY',
            startDate: moment(),
            endDate: moment(),
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            breeds: [],
            pagination: {
                pageSize: 20
            },
            selectedRowKeys: [],
            tableLoading: false,
            loading: false,
            addPoultryBatchVisible: false,
            retailerExtraDetails: {},
            rules:{
                batchId: [
                    { required: true, message: 'Please enter name' , trigger: 'change'},
                ],
                type: [
                    { required: true, message: 'Please select type', trigger: 'change' },
                ],
                age: [
                    { required: true, message: 'Please enter age', trigger: 'change' },
                ],
                size: [
                    { required: true, message: 'Please enter size', trigger: 'change' },
                ],
                
                phoneNumber: [
                        { required: true, message: 'Please enter phoneNumber' , trigger: 'change'},

                    ],
                sex: [
                    { required: true, message: 'Please enter sex', trigger: 'change' },
                ],
                reference: [
                    { required: true, message: 'Please enter reference', trigger: 'change' },
                ],
                address: [
                    { required: true, message: 'Please enter address', trigger: 'change' },
                ],
            }
        }
    },
    methods: {
        ...mapActions(['getRetailerAndCategoryAndOrders', 'addSubCustomer', 'getPoultries', 'setPoultryInfo', 'addPoultry']),
        onChange(date, dateString) {
            // console.log(date, dateString);
            this.startDate = dateString[0];
            this.endDate = dateString[1];
            // console.log("startDate | ", this.startDate);
            // console.log("endDate | ", this.endDate);
        },
        moment,
        closePoultryModal(){
            this.addPoultryBatchVisible = false
        },
        showPoultryModal(){
            this.addPoultryBatchVisible = true
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
        showMoreDetailsModal(data){
            this.setPoultryInfo(data);
            this.$router.push({
                name: 'poultry-details',
            }).catch(()=>{});
        },
        handleAddPoultryBatch(){
            this.$refs.addPoultryeRef.validate(async valid => {
                if (valid) {
                    this.loading = true;
                    
                    const request = {
                        id: this.customerDetails?.id,
                        data: {
                            batchNumber: this.addPoultryModel.batchId,
                            type: parseInt(this.addPoultryModel.type),
                            breedId: this.addPoultryModel.breed,
                            size: parseInt(this.addPoultryModel.size),
                            age: parseInt(this.addPoultryModel.age),
                            vaccineTemplate: parseInt(this.addPoultryModel.vaccineTemplate),
                            sourceId: this.addPoultryModel.sourceType ? parseInt(this.addPoultryModel.sourceType) : null,
                            source: this.addPoultryModel.source,
                            sourceContact: this.addPoultryModel.sourceContact,
                            notes: this.addPoultryModel.notes
                        }
                    }

                    const response = await this.addPoultry(request);
                         
                    this.loading = false
                    if(response.status === 200){
                        this.showSuccessAlert("New Poultry Batch Created Successfully")
                        this.loadPoultryBatches();
                        this.addPoultryModel = {
                            batchId: '',
                            type: '',
                            species: '',
                            breed: '',
                            size: '',
                            age: '',
                            vaccineTemplate: '',
                            source: '',
                            sourceType: '',
                            sourceContact: '',
                            notes: ''
                        },
                        this.addPoultryBatchVisible = false;
                    }else{
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        showInvoicePreview(data) {
            const retailer = this.availableRetailers.find(retailer => retailer.locationId === data.destinationLocationId)
            if (retailer) {
                this.invoiceData.retailerName = retailer.name
                this.invoiceData.retailerAddress = retailer.address
                this.invoiceData.phoneNumber = retailer.phoneNumber
            }

            this.invoiceData.dueDate = moment(data.createdAt).add(30, 'days').format("Do MMMM, YYYY") // 30 days 
            this.invoiceData.cowtribeDate = moment(data.createdAt).format("Do MMMM, YYYY")
            this.invoiceData.invoiceId = data.id
            this.invoiceData.total = data.total
            this.invoiceData.reference = null
            this.invoiceData.products = data.requestLines.map(product => ({
                id: product.id,
                productName: product.productBrandName,
                quantity: product.quantity,
                unitPrice: product.unitPrice,
                lineTotal: parseInt(product.quantity) * parseFloat(product.unitPrice)
            }))
            this.$refs.invoiceRef.showInvoiceForm(this.invoiceData);
        },

        downloadInvoice(data) {
            const retailer = this.availableRetailers.find(retailer => retailer.locationId === data.destinationLocationId)
            if (retailer) {
                this.invoiceData.retailerName = retailer.name
                this.invoiceData.retailerAddress = retailer.address
                this.invoiceData.phoneNumber = retailer.phoneNumber
            }

            this.invoiceData.dueDate = moment(data.createdAt).add(30, 'days').format("Do MMMM, YYYY") // 30 days 
            this.invoiceData.cowtribeDate = moment(data.createdAt).format("Do MMMM, YYYY")
            this.invoiceData.invoiceId = data.id
            this.invoiceData.total = data.total
            this.invoiceData.reference = null
            this.invoiceData.products = data.requestLines.map(product => ({
                id: product.id,
                productName: product.productBrandName,
                quantity: product.quantity,
                unitPrice: product.unitPrice,
                lineTotal: parseInt(product.quantity) * parseFloat(product.unitPrice)
            }))
            this.$refs.invoiceDownloadRef.downloadInvoice(this.invoiceData);
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        
        async loadPoultryBatches() {
            this.tableLoading = true
            
            const response = await this.getPoultries(this.id);
  
            this.tableLoading = false

            if (response.status === 200) {
                this.tablePoultry = [];
                response.data.data.forEach(poultry => {
                    this.tablePoultry.push({   
                        batchNumber: poultry.batchNumber ? poultry.batchNumber : "N/A",
                        key: poultry.batchNumber ? poultry.batchNumber : null,
                        type: poultry.poultryTypeLabel ? poultry.poultryTypeLabel : "N/A",
                        customerName: poultry.customerName ? poultry.customerName : "N/A",
                        poultrySpeciesLabel: poultry.poultrySpeciesLabel ? poultry.poultrySpeciesLabel : "N/A",
                        breed: poultry.breed ? poultry.breed : "N/A",
                        size: poultry.size ? poultry.size : "N/A",
                        age: poultry.age ? poultry.age : "N/A",
                        vaccineTemplateName: poultry.vaccineTemplateName ? poultry.vaccineTemplateName : "N/A",
                        source: poultry.source ? poultry.source : "N/A",
                        sourceName: poultry.sourceName ? poultry.sourceName : "N/A",
                        breedName: poultry.breedName ? poultry.breedName : "N/A",
                        createdAt: moment(poultry.createdAt).format("DD-MMM-YYYY"),
                        action: poultry
                    })
                })
            } else {
                // console.log("Error | ", response)
            }
        },

        async getBreeds() {
            const response = await this.$store.dispatch('breeds/getBreeds');
            if (response.status === 200) {
                this.breeds = response?.data?.data;
            }
        },

        async loadTemplates() {
            const response = await this.$store.dispatch('vaccineTemplate/getTemplates');
            if (response.status === 200) {
                this.templates = response?.data?.data;
            }
        },

        async loadSuppliers() {
            const response = await this.$store.dispatch('vaccineTemplate/getSuppliers', 1);
            if (response.status === 200) {
                this.suppliersTypes = response?.data?.data;
            }
        }        
    },
    computed: {
        ...mapGetters(['getCustomer', 'getSubCustomer']),
        displayDate() {
            return moment(this.customerDetails.createdAt).format("DD-MMM-YYYY")
        },
        displayPolutry() {
            return this.tablePoultry.length
        },
        displayTotalCustomerOrders() {
            return this.tableCustomerOrders.length
        },
        displayTotalCustomer() {
            return this.tableCustomers.length
        },
        
    },
    created() {
        if (this.getSubCustomer) {
            this.id = this.$route.params.id;
            this.customerDetails = this.getSubCustomer
            this.loadPoultryBatches();
            this.loadTemplates();
            this.getBreeds();
            this.loadSuppliers();
        }else{
            this.$router.push({
                name: 'customers',
            }).catch(()=>{});
        }
    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

a {
    color: #777777;
}

a:hover {
    color: #777777;
}

button:hover {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.tableStyle >>> .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #26A246;
    color: #fff;
  
}


.tableStyle >>> .ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle >>> .ant-table-header  {
    background: #fff !important;
}



</style>